import { Component, Input } from '@angular/core';
import { ClientConsultNoteTask } from '../../../core/models/client-consult-note-task.model';
import { ClientConsultNoteTaskStatus } from '../../../core/enums/client-consult-note-task-status.enum';
import { DecimalPipe, DatePipe } from '@angular/common';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { TaskEstimatedValueComponent } from '../../../shared/components/task-estimated-value/task-estimated-value.component';
import { ClientConsultNoteTaskClosedComponent } from '../client-consult-note-task-closed/client-consult-note-task-closed.component';
import { TaskStatusPipe } from '../../../shared/pipes/task-status.pipe';
import { PatientAlternateNamesComponent } from '../../../shared/components/patient-alternate-names/patient-alternate-names.component';

@Component({
    selector: 'app-client-consult-note-task-header',
    templateUrl: './client-consult-note-task-header.component.html',
    imports: [UserPresenceComponent,
              TaskEstimatedValueComponent,
              ClientConsultNoteTaskClosedComponent,
              DecimalPipe,
              DatePipe,
              TaskStatusPipe,
              PatientAlternateNamesComponent]
})
export class ClientConsultNoteTaskHeaderComponent {
  @Input() task: ClientConsultNoteTask;
  @Input() displayUserPresence = true;

  consultNoteTaskStatuses = ClientConsultNoteTaskStatus;

  constructor() {}
}
